<div class="driver-success-model">
   
    <p [innerHTML]="'Spot count has been updated successfully! Please update assigned parker list for this booking with new spot count'"></p>
    <div class="btn-outer">
        <p-button  label="OK"  (onClick)="closePopup()"/>

    </div>
</div>